import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-222f6ea8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-primary d-flex align-items-center",
  role: "alert"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "currentColor",
    class: "bi bi-exclamation-triangle-fill flex-shrink-0 me-2",
    viewBox: "0 0 16 16",
    role: "img",
    "aria-label": "Warning:"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " An example alert with an icon ")
], -1))
const _hoisted_4 = { class: "col-12 bg-light p-3" }
const _hoisted_5 = { class: "d-flex justify-content-between" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Order List", -1))
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table table-striped table-sm" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "PickUp Date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Country"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "City"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "user"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Payment"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Action")
  ])
], -1))
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "text-start" }
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = { class: "text-start" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "text-start" }
const _hoisted_21 = { class: "btn-group mr-2" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { colspan: "12" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Account Type", -1))
const _hoisted_26 = { class: "col-sm-3 text-end" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Business Name", -1))
const _hoisted_28 = { class: "col-sm-3 text-end" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package Total", -1))
const _hoisted_31 = { class: "col-sm-3 text-end" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Distance Cost", -1))
const _hoisted_33 = { class: "col-sm-3 text-end" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Type", -1))
const _hoisted_36 = { class: "col-sm-3 text-end" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Pickup Address", -1))
const _hoisted_38 = { class: "col-sm-3 text-end" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Courier Note", -1))
const _hoisted_41 = { class: "col-sm-3 text-end" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Tax", -1))
const _hoisted_43 = { class: "col-sm-3 text-end" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Cancel Note", -1))
const _hoisted_46 = { class: "col-sm-3 text-end" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "is Paid", -1))
const _hoisted_48 = { class: "col-sm-3 text-end" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Tip", -1))
const _hoisted_53 = { class: "col-sm-3 text-end" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Created Date ", -1))
const _hoisted_56 = { class: "col-sm-3 text-end" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Updated Date", -1))
const _hoisted_58 = { class: "col-sm-3 text-end" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Rider Detail", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_63 = { class: "row" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Name", -1))
const _hoisted_65 = { class: "col-sm-3 text-end" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Phone", -1))
const _hoisted_67 = { class: "col-sm-3 text-end" }
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<br data-v-222f6ea8><h6 class=\"text-start\" data-v-222f6ea8>Payment Detail</h6><hr data-v-222f6ea8><div class=\"row\" data-v-222f6ea8><div class=\"col-sm-3 text-start fw-bold\" data-v-222f6ea8>comming Soon</div><div class=\"col-sm-3 text-end\" data-v-222f6ea8></div><div class=\"col-sm-3 text-start fw-bold\" data-v-222f6ea8>comming soon</div><div class=\"col-sm-3 text-end\" data-v-222f6ea8></div></div>", 4)
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Item Detail", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_75 = { class: "row" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Item Id", -1))
const _hoisted_77 = { class: "col-sm-3 text-end" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Total Cost", -1))
const _hoisted_79 = { class: "col-sm-3 text-end" }
const _hoisted_80 = { class: "row" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Distance Type", -1))
const _hoisted_82 = { class: "col-sm-3 text-end" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Distance Cost ", -1))
const _hoisted_84 = { class: "col-sm-3 text-end" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package", -1))
const _hoisted_87 = { class: "col-sm-3 text-end" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package Cost ", -1))
const _hoisted_89 = { class: "col-sm-3 text-end" }
const _hoisted_90 = { class: "row" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Customer Name", -1))
const _hoisted_92 = { class: "col-sm-3 text-end" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Customer Email ", -1))
const _hoisted_94 = { class: "col-sm-3 text-end" }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Customer Phone", -1))
const _hoisted_97 = { class: "col-sm-3 text-end" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Customer Address ", -1))
const _hoisted_99 = { class: "col-sm-3 text-end" }
const _hoisted_100 = { class: "row" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Courier Note", -1))
const _hoisted_102 = { class: "col-sm-3 text-end" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Is Delivered ", -1))
const _hoisted_104 = { class: "col-sm-3 text-end" }
const _hoisted_105 = { class: "row" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Delivered Date", -1))
const _hoisted_107 = { class: "col-sm-3 text-end" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Action ", -1))
const _hoisted_109 = { class: "col-sm-3 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AdminPagination = _resolveComponent("AdminPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("a", {
            href: "javascript:void(0)",
            class: "btn btn-sm btn-primary align-self-center",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.exportCSV && $setup.exportCSV(...args)))
          }, "Export")
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orders, (order) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: order.id
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_11, _toDisplayString(order.id), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(order.total_price), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString($options.dateTime(order.pickup_date)), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(order.country?.name), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(order.city?.name), 1),
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("a", {
                        href: `/users/${order.user?.id}/view`
                      }, _toDisplayString(order.user?.full_name), 9, _hoisted_17)
                    ]),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(order.orderstatus?.name), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(order.paymentmethod?.name), 1),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("a", {
                          href: "javascript:void(0)",
                          class: "btn btn-sm btn-primary me-2",
                          onClick: ($event: any) => ($setup.select(order.id,order.rider_id))
                        }, " View", 8, _hoisted_22),
                        _createVNode(_component_router_link, {
                          to: `/orders/${order.id}/edit`,
                          class: "btn btn-sm btn-secondary me-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Edit")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_23, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["overflow-hidden", $setup.selected=== order.id ? 'show': 'hide' ])
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, _toDisplayString(order.user?.account_type), 1),
                          _hoisted_27,
                          _createElementVNode("div", _hoisted_28, _toDisplayString(order.user?.bussiness_name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, _toDisplayString(order.total_package_price), 1),
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, _toDisplayString(order.total_distance), 1)
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("div", _hoisted_36, _toDisplayString(order.distance_type), 1),
                          _hoisted_37,
                          _createElementVNode("div", _hoisted_38, _toDisplayString(order.pickup_address), 1)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("div", _hoisted_41, _toDisplayString(order.courier_note), 1),
                          _hoisted_42,
                          _createElementVNode("div", _hoisted_43, _toDisplayString(order.tax), 1)
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _createElementVNode("div", _hoisted_46, _toDisplayString(order.cancel_note), 1),
                          _hoisted_47,
                          _createElementVNode("div", _hoisted_48, _toDisplayString(order.is_paid), 1)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _hoisted_51,
                          _hoisted_52,
                          _createElementVNode("div", _hoisted_53, _toDisplayString(order.total_rider_tip), 1)
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _hoisted_55,
                          _createElementVNode("div", _hoisted_56, _toDisplayString($options.dateTime(order.created_at)), 1),
                          _hoisted_57,
                          _createElementVNode("div", _hoisted_58, _toDisplayString($options.dateTime(order.updated_at)), 1)
                        ]),
                        (order.rider_id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                              _hoisted_60,
                              _hoisted_61,
                              _hoisted_62,
                              _createElementVNode("div", _hoisted_63, [
                                _hoisted_64,
                                _createElementVNode("div", _hoisted_65, _toDisplayString($setup.rider.rider_name), 1),
                                _hoisted_66,
                                _createElementVNode("div", _hoisted_67, _toDisplayString($setup.rider.rider_mobile_no), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_68,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.order_items, (orderitem) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: orderitem.id
                          }, [
                            _hoisted_72,
                            _hoisted_73,
                            _hoisted_74,
                            _createElementVNode("div", _hoisted_75, [
                              _hoisted_76,
                              _createElementVNode("div", _hoisted_77, _toDisplayString(orderitem.id), 1),
                              _hoisted_78,
                              _createElementVNode("div", _hoisted_79, _toDisplayString(orderitem.price), 1)
                            ]),
                            _createElementVNode("div", _hoisted_80, [
                              _hoisted_81,
                              _createElementVNode("div", _hoisted_82, _toDisplayString(orderitem.distance_type), 1),
                              _hoisted_83,
                              _createElementVNode("div", _hoisted_84, _toDisplayString(orderitem.distance_price), 1)
                            ]),
                            _createElementVNode("div", _hoisted_85, [
                              _hoisted_86,
                              _createElementVNode("div", _hoisted_87, _toDisplayString(orderitem.package?.name), 1),
                              _hoisted_88,
                              _createElementVNode("div", _hoisted_89, _toDisplayString(orderitem.package_price), 1)
                            ]),
                            _createElementVNode("div", _hoisted_90, [
                              _hoisted_91,
                              _createElementVNode("div", _hoisted_92, _toDisplayString(orderitem.customer_name), 1),
                              _hoisted_93,
                              _createElementVNode("div", _hoisted_94, _toDisplayString(orderitem.customer_email), 1)
                            ]),
                            _createElementVNode("div", _hoisted_95, [
                              _hoisted_96,
                              _createElementVNode("div", _hoisted_97, _toDisplayString(orderitem.customer_phone), 1),
                              _hoisted_98,
                              _createElementVNode("div", _hoisted_99, _toDisplayString(orderitem.customer_address), 1)
                            ]),
                            _createElementVNode("div", _hoisted_100, [
                              _hoisted_101,
                              _createElementVNode("div", _hoisted_102, _toDisplayString(orderitem.courier_note), 1),
                              _hoisted_103,
                              _createElementVNode("div", _hoisted_104, _toDisplayString(orderitem.is_delivered), 1)
                            ]),
                            _createElementVNode("div", _hoisted_105, [
                              _hoisted_106,
                              _createElementVNode("div", _hoisted_107, _toDisplayString(orderitem.delivered_date), 1),
                              _hoisted_108,
                              _createElementVNode("div", _hoisted_109, [
                                _createVNode(_component_router_link, {
                                  to: `/rateranges/${orderitem.id}/edit`,
                                  class: "btn btn-sm btn-secondary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Edit")
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ])
                            ])
                          ], 64))
                        }), 128))
                      ], 2)
                    ])
                  ])
                ], 64))
              }), 128))
            ])
          ])
        ])
      ]),
      _createVNode(_component_AdminPagination, {
        "last-page": $setup.lastPage,
        onPageChanged: _cache[1] || (_cache[1] = ($event: any) => ($setup.load($event)))
      }, null, 8, ["last-page"])
    ])
  ]))
}